import { render, staticRenderFns } from "./SidebarTabExternalSection.vue?vue&type=template&id=9785f99e"
import script from "./SidebarTabExternalSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarTabExternalSection.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports